export default defineNuxtPlugin(() => {
  const { $site } = useNuxtApp()

  // Google analytics integration
  if ($site.integrations) {
    const integration = $site.integrations['1d8fbf495ebabf8c5cad1a8c2bf97662']
    const trackingID = integration && integration.data && integration.enabled ? integration.data.trackingID : null

    if (trackingID) {
      // Cookie.vue initializes Google Analytics after explicit consent.
      useState('gtagTrackingID', () => trackingID)
    }
  }
})
